import { createContext, useContext } from 'react';

export const ReportContext = createContext({});

/**
 * Simple pass-through provider for report data
 * Data fetching now happens in the LandingPage component via useReportQueries hook
 * This context just provides the data to child components
 */

export function useReport() {
  const context = useContext(ReportContext);

  if (!context) {
    throw new Error('useReportContext must be used within an ReportContext');
  }
  return context;
}
